import { connect } from 'react-redux';

import {
  ADD_ROOM_FACILITIES,
  GET_LIST_ROOM_OF_PLACE,
  GET_ROOM_FACILITIES,
} from 'store/place/actionTypes';
import actionGetSetting from 'store/setting/actions';

import ConvenienceRoom from './ConvenienceRoom';

const mapStateToProps = (state) => ({
  isLoadingAddRoomFacilities: state.Place.isLoadingAddRoomFacilities,
  isLoadingGetRoomFacilities: state.Place.isLoadingGetRoomFacilities,
  isLoadingGetSetting: state.Setting.isLoadingGetSetting,

  roomFacilities: state.Place.roomFacilities,
  roomOfPlaceList: state.Place.roomOfPlaceList,
  setting: state.Setting.setting,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetSetting: (payload) => dispatch(actionGetSetting(payload)),

  actionGetRoomFacilities: (payload) => dispatch({
    type: GET_ROOM_FACILITIES,
    payload,
  }),

  actionAddRoomFacilities: (payload) => dispatch({
    type: ADD_ROOM_FACILITIES,
    payload,
  }),

  actionGetListRoomsOfPlace: (payload) => {
    dispatch({
      type: GET_LIST_ROOM_OF_PLACE,
      payload,
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ConvenienceRoom);
